import { format } from 'date-fns'

// TODO: consider ripping this out and using the library directly
// in order to make it easier to tell exactly how the date is being formatted
export default function formatDate(date) {
  return format(date, 'dddd, MMMM DD, YYYY')
}
